import config from 'styles/config'

export default {
  postcodeWrapper: {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '44%',
    paddingRight: 16
  },
  countryWrapper: {
    display: 'inline-block',
    width: '56%',
    verticalAlign: 'top'
  },

  [config.mediaQueries.tabletPortrait]: {
    postcodeWrapper: {
      width: '36%',
      paddingRight: 9,
    },
    countryWrapper: {
      width: '64%',
    },
  }
}
